module.exports = __webpack_public_path__ + "static/media/litho_4.0d643ddc.jpg";